module.exports = __webpack_public_path__ + "img/kkiokioBg.2aeff75f.svg";